import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=63c3a4ec&scoped=true"
import script from "./ProductOrder.vue?vue&type=script&lang=js"
export * from "./ProductOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductOrder.vue?vue&type=style&index=0&id=63c3a4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3a4ec",
  null
  
)

export default component.exports